import { useContext } from 'react';
import { FeatureFlagsContext } from '../providers/feature-flags-provider';
import { logger } from '~/logger/logger';

export function useFeatureFlags() {
  const context = useContext(FeatureFlagsContext);

  if (context === undefined) {
    logger.error('useFeatureFlags must be used within a FeatureFlagsProvider');
  }

  return context;
}
